import React, { useCallback, useEffect, useMemo, useState } from "react";

import "./HomeTemplate.scss";

import ClienteService from "../../services/cliente";

import Page, { redirect } from "../../components/Layout/Page/Page";

import Sidebar from "../../components/Navigation/Sidebar/Sidebar";

import NavBar from "../../components/Navigation/NavBar/NavBar";
import { IconHouse } from "../../components/Icons/IconHouse";
import { IconDelivery } from "../../components/Icons/IconDelivery";
import { IconConsumption } from "../../components/Icons/IconConsumption";
import { IconSettings } from "../../components/Icons/IconSettings";
import { IconMoney } from "../../components/Icons/IconMoney";
import { IconCardId } from "../../components/Icons/IconCardId";
import { IconTelephone } from "../../components/Icons/IconTelephone";
import { IconAvatar } from "../../components/Icons/IconAvatar";
import { IconMarker } from "../../components/Icons/IconMarker";
import { IconHouseSidebar } from "../../components/Icons/IconHouseSidebar";
import { IconList } from "../../components/Icons/IconList";
import { IconEnterpriseSidebar } from "../../components/Icons/IconEnterpriseSidebar";
import { IconLockSidebar } from "components/Icons/IconLock";
import { useAuth } from "hooks/useAuth";

export { redirect } from "../../components/Layout/Page/Page";

const HomeTemplate = (props) => {
  const { history, className, children } = props;
  const { isAdm } = useAuth();

  const [sidebarIn, setSidebarIn] = useState(false);

  const featureFlagNovaFormaAcessoIndustrial = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_INDUSTRIAL === "true";

  useEffect(() => {
    if (!ClienteService.isLoggedIn) {
      redirect({ history }, "/");
    }
  }, [history]);

  const handleToggleSidebar = useCallback(() => {
    setSidebarIn((prevState) => !prevState);
  }, []);

  const { segmento } = ClienteService.localEntrega || {};

  const sidebarOpts = useMemo(
    () =>
      [
        {
          label: "Home",
          icon: <IconHouseSidebar />,
          onClick: () => redirect({ history }, "/home"),
          path: "/home",
        },
        {
          label: "Dados pessoais",
          icon: <IconCardId />,
          onClick: () => redirect({ history }, "/personal-data"),
          path: "/personal-data",
        },
        (segmento === "INDUSTRIAL" && featureFlagNovaFormaAcessoIndustrial && {
          label: "Meus CNPJs",
          icon: <IconEnterpriseSidebar />,
          onClick: () => redirect({ history }, "/my-cnpjs"),
          path: "/my-cnpjs",
        }) ||
          null,
        (segmento === "INDUSTRIAL" && featureFlagNovaFormaAcessoIndustrial &&
          isAdm && {
            label: "CPF de acesso",
            icon: <IconLockSidebar />,
            onClick: () => redirect({ history }, "/register-cpf-access"),
            path: "/register-cpf-access",
          }) ||
          null,
        (segmento === "INDUSTRIAL" && {
          label: "Contatos da empresa",
          icon: <IconTelephone />,
          onClick: () => redirect({ history }, "/industrial-contact"),
          path: "/industrial-contact",
        }) ||
          null,
        (segmento === "INDUSTRIAL" && {
          label: "Indicação de clientes",
          icon: <IconAvatar />,
          path: "/recommendation",
          onClick: () => redirect({ history }, "/recommendation"),
        }) ||
          null,
        {
          label:
            segmento === "INDUSTRIAL"
              ? "Meus locais de entrega"
              : "Meus endereços",
          onClick: () => redirect({ history }, "/address-list"),
          icon: <IconMarker />,
          path: "/address-list",
        },
        (segmento !== "INDUSTRIAL" && {
          label: "Lista de protocolos",
          onClick: () =>
            redirect({ history }, "/home-services", { tab: "protocol" }),
          icon: <IconList />,
          path: "/home-services",
        }) ||
          null,
      ].filter((e) => e),
    [history, segmento, isAdm]
  );

  const navbarTabs = useMemo(
    () => [
      {
        label: "Home",
        icon: <IconHouse />,
        onClick: () => redirect({ history }, "/home"),
        path: "/home",
      },
      {
        label: "Consumo",
        icon: <IconConsumption />,
        onClick: () => redirect({ history }, "/consumption"),
        path: "/consumption",
      },
      {
        label: "Financeiro",
        icon: <IconMoney />,
        onClick: () => redirect({ history }, "/finances"),
        path: "/finances",
      },
      segmento !== "LICITACAO" && {
        label: "Serviços",
        icon: <IconSettings />,
        onClick: () => redirect({ history }, "/home-services"),
        path: "/home-services",
      },
      segmento === "INDUSTRIAL" && {
        label: "Entregas",
        icon: <IconDelivery />,
        onClick: () => redirect({ history }, "/home-delivery"),
        path: "/home-delivery",
      },
    ],
    [history, segmento, isAdm]
  );

  return (
    <>
      <Page history={history} whiteBackground={true}>
        <NavBar
          tabs={navbarTabs}
          onToggleSidebar={handleToggleSidebar}
          sidebarOpen={sidebarIn}
        />
        <Sidebar tabs={navbarTabs} open={sidebarIn} menuItems={sidebarOpts} />
        <div className={`home-template ${className || ""}`}>
          <div className="content">{children}</div>
        </div>
      </Page>
    </>
  );
};

export default HomeTemplate;
